export const enum SupportChatInvoicingStatus {
    Enabled = 0,
    Disabled = 1,
    Unknown = 2
}
